import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatCurrency = (value: number, currency: string = 'USD') => 
  new Intl.NumberFormat('en-US', { 
    style: 'currency', 
    currency, 
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0, 
    maximumFractionDigits: 0 
  }).format(value);